export default function createVerityCheckboxLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `verity-checkbox:${input.type}` });
    return {
        injectionSkipped(reason) {
            return log({
                type: "injection-skipped",
                details: { reason },
            });
        },
        injected(options) {
            return log({
                type: "injected",
                details: options,
            });
        },
        initialOptionsReceived(configuration, options) {
            return log({
                type: "initial-configuration-received",
                details: {
                    configuration,
                    options,
                },
            });
        },
        statusChanged(enabled) {
            return log({
                type: "status-changed",
                details: { enabled },
            });
        },
    };
}
